// Renouvelle le jeton d'accès Directus avant son expiration (appareil de confiance) ou déconnecte l'utilisateur
// à l'expiration du JWT (session sans appareil de confiance), tant que l'application est ouverte.
const CHECK_INTERVAL_MS = 30_000
const RENEW_BEFORE_EXPIRY_MS = 120_000

export default defineNuxtPlugin((nuxtApp) => {
  const userStore = useUserStore()
  const router = useRouter()
  const { token, expires } = useDirectusToken()
  const trust = useDeviceTrust()

  let running = false

  const check = async () => {
    if (running || document.visibilityState !== 'visible') {
      return
    }

    if (!userStore.isLoggedIn || !token.value || !router.currentRoute.value.path.startsWith('/volontaires')) {
      return
    }

    // Appareil de confiance : renouvellement en avance. Sans appareil de confiance : seulement une fois le JWT expiré.
    const threshold = trust.isUntrustedSession() ? 0 : RENEW_BEFORE_EXPIRY_MS
    // Calcul direct : le computed token_expires_in de useDirectusToken ne dépend pas de l'heure et peut rester figé
    if (Math.max(0, (expires.value ?? 0) - Date.now()) > threshold) {
      return
    }

    running = true
    try {
      if (!(await trust.renewSession())) {
        trust.endSession()
        userStore.logout()
        await navigateTo('/volontaires/connexion')
      }
    }
    catch {
      // Panne réseau ou serveur : pas de déconnexion, nouvel essai au prochain passage
    }
    finally {
      running = false
    }
  }

  setInterval(check, CHECK_INTERVAL_MS)
  document.addEventListener('visibilitychange', check)
  // Reprise après veille ou retour du réseau : les minuteurs ont pu être suspendus
  window.addEventListener('focus', check)
  window.addEventListener('online', check)
  nuxtApp.hook('page:start', check)
})
